import React from 'react';
import img from '../../../src/images/giphy.gif';

const PlaceOrder = () => {
    return (
        <div>
            <img style={{ display: 'block', margin: 'auto', marginTop: '25px' }} src={img} alt="" />
        </div>
    );
};

export default PlaceOrder;